export default "__VITE_ASSET__B87jxIQc__"